module.exports = __webpack_public_path__ + "components/profile/static/icon-heart-red-ef7af09607fb064986c98510c5d430a2.svg";